import { render } from "./feature.vue?vue&type=template&id=be869262"
const script = {}

import "./feature.vue?vue&type=style&index=0&id=be869262&lang=css"

import exportComponent from "X:\\Proyecto\\riego-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__